import { Route } from 'react-router-dom'

import { ForbiddenPage } from '@pages/forbidden-page/ForbiddenPage'
import { REDIRECT_URLS } from '../../../constants'

export const ForbiddenRoute = () => {
  return <Route path={REDIRECT_URLS.FORBIDDEN_PAGE} exact render={() => <ForbiddenPage />} />
}
